export const iconFontAwesomeSocialIcons = (
	<i className="fa-solid fa-icons"></i>
);
